const { Cookies: Cookies_ } = require("react-cookie");
const cook = new Cookies_();

export const isX_Bonita_API_Token = () => {
  const X_Bonita_API_Token = cook.get("X-Bonita-API-Token");

  if (
    X_Bonita_API_Token === null ||
    X_Bonita_API_Token === undefined ||
    X_Bonita_API_Token === ""
  ) {
    return false;
  } else {
    return true;
  }
};
export const isAuth = () => {
  const authenticated = localStorage.getItem("authenticated")
    ? localStorage.getItem("authenticated")
    : "false";
  const user = localStorage.getItem("user")
    ? localStorage.getItem("user")
    : null;
  if (user === null || authenticated === null || authenticated === "false") {
    return false;
  } else {
    return true;
  }
};
export const isLogin = () => {
  const authenticated = localStorage.getItem("authenticated")
    ? localStorage.getItem("authenticated")
    : "false";

  if (authenticated === null || authenticated === "false") {
    return false;
  } else {
    return true;
  }
};
